import { render, staticRenderFns } from "./ModalTransactionsDetail.vue?vue&type=template&id=507de3ed&"
import script from "./ModalTransactionsDetail.vue?vue&type=script&lang=js&"
export * from "./ModalTransactionsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports